import Axios from "axios";
import { LoadingBar, Message } from "view-design";
import Querystring from "qs";
import { get } from "lodash-es";
import { getToken, getLoginType, getUrlKey } from "../utils/ls_provider";
import vm from "../main";

const baseURL = "/api";
const instance = Axios.create({
  baseURL,
  timeout: 5000
});
// http request 拦截器
instance.interceptors.request.use(
  req => {
    LoadingBar.start();
    return req;
  },
  err => {
    console.log(err);
    LoadingBar.error();
    return Promise.reject(err);
  }
);

// http response 拦截器
instance.interceptors.response.use(
  res => {
    LoadingBar.finish();
    return res.data;
  },
  err => {
    LoadingBar.error();
    const code = get(err, "response.data.errcode");
    const status = get(err, "response.status");
    if (status === 401) {
      switch (code) {
        case "AuthFailure.NotInOnesAI":
          Message.error("您的邮箱不是ONES.AI的公司邮箱");
          vm.$router.push({ name: "unauthorized" });
          break;
        case "AuthFailure.InvalidToken":
          Message.error("登录过期请重新登录");
          localStorage.clear();
          vm.$router.push({ name: "login" });
          break;
        case "AuthFailure.NoAccessToShowCodeTable":
          Message.error("您的账号尚未拥有访问ONES CRM的权限");
          vm.$router.push({ name: "unauthorized" });
          break;
        default:
          Message.error("登录过期请重新登录");
          localStorage.clear();
          vm.$router.push({ name: "login" });
      }
    } else if (status === 403) {
      vm.$router.push({ name: "unauthorized_single_page" });
    } else if (status > 500) {
      Message.error("服务器貌似开小差了ㄟ( ▔, ▔ )ㄏ,请联系管理员");
    } else {
      Message.error(code);
    }
    return Promise.reject(err);
  }
);

function mergeTokenQS(QSObj = {}) {
  return `?${Querystring.stringify(
    Object.assign({}, { type: getLoginType() }, { token: getToken() }, QSObj)
  )}`;
}

export function getLogs(qs) {
  return instance.get(`/logs${mergeTokenQS(qs)}`);
}

export function updateOrgs(orgID, params) {
  return instance.post(`/org/${orgID}/update${mergeTokenQS()}`, params).then(res => {
    Message.success({
      content: "操作成功"
    });
    return res;
  });
}

export function getTeams(qs, params) {
  return instance.post(`/teams${mergeTokenQS(qs)}`, params);
}

export function getOrgDetail(orgID) {
  return instance.get(`/org/${orgID}${mergeTokenQS()}`);
}

export function getOrders(qs, params) {
  return instance.post(`/orders${mergeTokenQS(qs)}`, params);
}

export function getOrderDetail(orderNo) {
  return instance.get(`/order/${orderNo}${mergeTokenQS()}`);
}

export function getOrderTransferInfo(orderNo) {
  return instance.get(`/order/${orderNo}/transfer_info${mergeTokenQS()}`);
}

export function receiveOrderTransfer(orderNo) {
  return instance.post(`/order/${orderNo}/receive_transfer${mergeTokenQS()}`);
}

export function exportOrders(orderNos) {
  return instance.post(
    `/orders/export${mergeTokenQS()}`,
    {
      order_nos: orderNos
    },
    {
      responseType: "blob"
    }
  );
}

export function getMembers() {
  return instance.get(`/members${mergeTokenQS()}`);
}

export function addMember(params) {
  return instance.post(`/members/add${mergeTokenQS()}`, params);
}

export function editMember(memberUUID, params) {
  return instance.post(`/member/${memberUUID}/update${mergeTokenQS()}`, params);
}

export function deleteMembers(user_uuids) {
  return instance.post(`/members/delete${mergeTokenQS()}`, {
    user_uuids
  });
}

export function getCoupons(qs, params) {
  return instance.post(`/coupon_codes${mergeTokenQS(qs)}`, params);
}

export function addCoupons(params) {
  return instance.post(`/coupon_codes/add${mergeTokenQS()}`, params);
}

export function disableCoupons(params) {
  return instance.post(`/coupon_codes/disable${mergeTokenQS()}`, params);
}

export function getMyInfo() {
  return instance.get(`/me${mergeTokenQS()}`);
}

export function validateToken() {
  let token = getUrlKey("token");
  if (token && token != "") {
    localStorage.setItem("TOKEN", token);
  }
  let _type = getUrlKey("type");
  if (_type && _type != "") {
    localStorage.setItem("LOGIN_TYPE", _type);
  }
}

export function getCrmConfig() {
  return instance.get('/config');
}

export default {
  install(Vue) {
    // eslint-disable-next-line
    Vue.prototype.$http = instance;
  }
};
